import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const leagueRow = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: vars.radii.m,
  backgroundColor: vars.colors.bgColor,
  padding: `${vars.space.xs} ${vars.space.m}`,
  textDecoration: "none",
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.m,
});

export const movementStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
});

export const rank = style({
  fontFamily: vars.fonts.bold,
});

export const leagueSummaryWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const leaguesWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space["2xs"],
});

export const tntLeagueRow = style({
  borderRadius: vars.radii.m,
  backgroundColor: vars.colors.bgColor,
  padding: "0.2rem",
});
